import api from '../../../api.js'
import {handleResponseErrors} from '../../services/processServerErrors.js'

export async function submitUser(values) {
  return api.users.edit(values).catch(handleResponseErrors)
}

export async function submitFreelance(values, editInterview = false) {
  if (values.fonctions) {
    values.fonctions = values.fonctions.map((fonction) => ({name: fonction.name}))
  }
  if (values.expertises) {
    values.expertises = values.expertises.map((expertise) => ({name: expertise.name}))
  }
  if (values.master_skills) {
    values.master_skills = values.master_skills.map((masterSkill) => ({name: masterSkill.name}))
  }
  if (values.secteurs) {
    values.secteurs = values.secteurs.map((secteur) => secteur.id || secteur)
  }
  if (values.it_skills) {
    values.it_skills = values.it_skills.map((itSkill) => ({name: itSkill.name})
    )
  }

  // At this point freelance agent relationship object should not be present
  if (editInterview) {
    return api.freelances.editInterview(values).catch(handleResponseErrors)
  } else {
    return api.freelances.edit(values).catch(handleResponseErrors)
  }
}

export default submitUser
